import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Creators as SubscriptionCreators } from '../../../store/ducks/subscription';
import Loading from '../../../components/Loading';
import { translateDate } from '../../../components/Time';

class AdminPayments extends Component {
  static propTypes = {
    getPaymentsRequest: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired,
    payments: PropTypes.shape.isRequired,
  };

  componentWillMount() {
    this.props.getPaymentsRequest(this.props.user.id);
  }

  render() {
    return (
      <Fragment>
        <h1 className="title-underline">Pagamentos</h1>

        {this.props.payments.loading && <Loading />}

        {!this.props.payments.loading &&
          typeof this.props.payments.data === 'undefined' && <p>Nenhum pagamento registrado.</p>}

        {typeof this.props.payments.data !== 'undefined' &&
          this.props.payments.data.length > 0 && (
            <table className="table">
              <thead>
                <tr className="table-secondary">
                  <th scope="col">Data</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              {this.props.payments.data.map(payment => (
                <tr>
                  <td>{translateDate({ date: payment.payment_date })}</td>
                  <td>{payment.amount}</td>
                </tr>
              ))}
            </table>
          )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  payments: state.subscription.payments,
  user: state.user,
});

const mapDispatchToProps = dispatch => bindActionCreators(SubscriptionCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminPayments);



// WEBPACK FOOTER //
// ./src/pages/admin/payment/index.js